import Draft from "draft-js";
import { createSelection } from "./createSelection";

/**
 * Move selection to the end of the passed-in selection
 */
export const moveToEndOfSelection = (
  selection: Draft.SelectionState,
): Draft.SelectionState =>
  createSelection({
    anchorKey: selection.getEndKey(),
    anchorOffset: selection.getEndOffset(),
    focusKey: selection.getEndKey(),
    focusOffset: selection.getEndOffset(),
    hasFocus: true,
    isBackward: false,
  });
